import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Typography, Grid, List, ListItem, Link } from "@mui/material";

const sitemapData = [
  {
    heading: "Main Pages",
    links: [
      { label: "Home", href: "/" },
      { label: "About Us", href: "/about" },
      { label: "Contact Us", href: "/contact" },
      { label: "Blog", href: "https://medium.com/@f9tech", external: true },
    ],
  },
  {
    heading: "Services",
    links: [
      { label: "Mobile App Development", href: "/services" },
      { label: "Web App Development", href: "/services" },
      { label: "Digital Marketing", href: "/services" },
      { label: "Graphic Designing", href: "/services" },
      { label: "UI/UX Design", href: "/services" },
      { label: "Business Solutions", href: "/solutions" },
    ],
  },
  {
    heading: "Solutions",
    links: [
      { label: "F9 CRM", href: "/solutions" },
      { label: "Association Management", href: "/solutions" },
      { label: "Flutter CMS", href: "/solutions" },
      { label: "PR CMS", href: "/solutions" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Terms & Conditions", href: "/terms" },
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Sitemap", href: "/sitemap" },
    ],
  },
  {
    heading: "Follow Us",
    links: [
      { label: "LinkedIn", href: "https://www.linkedin.com/company/f9-info-technologies", external: true },
      { label: "YouTube", href: "https://www.youtube.com/@f9tech/videos", external: true },
      { label: "GitHub", href: "https://github.com/F9info", external: true },
      { label: "Instagram", href: "https://www.instagram.com/f9tech", external: true },
      { label: "Facebook", href: "https://www.facebook.com/f9tech", external: true },

    ],
  },
];

class Sitemap extends Component {
  render() {
    return (
      <Box sx={{ py: 13 }}>
        <Helmet>
          <title>Sitemap | F9 Info Technologies</title>
          <meta name="description" content="Browse all pages of F9 Info Technologies — services, solutions, about us, blog and more." />
        </Helmet>
        <Container maxWidth="lg" className="container">
          <Typography variant="h1" component="h1" className="page-title" align="center" sx={{ mb: 2 }}>
            Sitemap
          </Typography>
          <Typography align="center" sx={{ mb: 8, color: "text.secondary" }}>
            A complete directory of all pages on the F9 Info Technologies website.
          </Typography>

          <Grid container spacing={6}>
            {sitemapData.map((section) => (
              <Grid item xs={12} sm={6} md={4} key={section.heading}>
                <Typography
                  variant="h6"
                  component="h2"
                  sx={{ fontWeight: 700, color: "#002E69", mb: 1, textTransform: "uppercase", letterSpacing: 1 }}
                >
                  {section.heading}
                </Typography>
                <Box sx={{ width: 40, height: 3, bgcolor: "primary.main", mb: 2 }} />
                <List disablePadding>
                  {section.links.map((link) => (
                    <ListItem key={link.label} disableGutters sx={{ py: 0.5 }}>
                      <Link
                        href={link.href}
                        {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        underline="hover"
                        sx={{ color: "#444", fontSize: "0.95rem", "&:hover": { color: "primary.main" } }}
                      >
                        {link.label}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default Sitemap;
